import { hubsFor } from '@kronos/domain'
import type { Hub, Role } from '@kronos/domain'
import type { Route } from '../router'

/**
 * What each place is called, which icon it wears, and where it goes. The
 * *which* comes from the domain (`hubsFor`), so the nav and the server's idea
 * of who may do what cannot drift.
 */
export interface Place {
  readonly id: Hub
  readonly label: string
  readonly icon: string
  readonly to: Route
}

const PLACE: Readonly<Record<Hub, Place>> = {
  today: { id: 'today', label: 'Today', icon: 'today', to: { name: 'today' } },
  schedule: { id: 'schedule', label: 'Schedule', icon: 'plan', to: { name: 'schedule' } },
  hours: { id: 'hours', label: 'Hours', icon: 'hours', to: { name: 'hours' } },
  work: { id: 'work', label: 'Work', icon: 'work', to: { name: 'work' } },
  receive: { id: 'receive', label: 'Intake', icon: 'receive', to: { name: 'receive', item: null } },
  inventory: { id: 'inventory', label: 'Inventory', icon: 'stock', to: { name: 'inventory' } },
  fleet: { id: 'fleet', label: 'Fleet', icon: 'fleet', to: { name: 'fleet' } },
  build: { id: 'build', label: 'Build', icon: 'builds', to: { name: 'build', section: null } },
  design: { id: 'design', label: 'Design', icon: 'catalog', to: { name: 'design' } },
  people: { id: 'people', label: 'People', icon: 'office', to: { name: 'people', section: null } },
  connectivity: { id: 'connectivity', label: 'Connectivity', icon: 'network', to: { name: 'connectivity', section: null } },
}

/** Everywhere this person can go, in nav order. */
export function placesFor(roles: readonly Role[]): readonly Place[] {
  return hubsFor(roles).map((hub) => PLACE[hub])
}

/**
 * A phone bar holds four places and More; More holds the rest and the account.
 * Four because that is exactly a technician's day: Today, Schedule, Hours, Work.
 */
export const PHONE_SLOTS = 4
